import React from 'react';
import NavAdmin from '../nav-admin/nav-admin';

const HeaderDashboard = () => (
    <header className="HeaderDashboard" role="banner">
        <nav
            className="navbar navbar-expand-sm navbar-toggleable-sm box-shadow admin-custom-navbar"
            aria-label="Dashboard header bar with admin navigation"
        >
            <div className="container w-max2">
                <h5 className="sp-mx" id="dashboard-header-title">
                    <i className="bi bi-grid-3x3-gap" aria-hidden="true"></i>
                    <span className="spacer-margin2 v-set4">Dashboard </span>
                </h5>
                <NavAdmin />
            </div>
        </nav>
    </header>
);

export default HeaderDashboard;
